import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../components/Icon';
import Text from '../../../../components/Text';
import { makeQAAttributes } from '../../../../utils/qaAttributes';
import { QA_CHAT_HISTORY_PAGE } from '../../../../constants/qaAttributes';

const ChatStatus = ({ name, status }) => (
  <div className="sp-ticket-status" {...makeQAAttributes(QA_CHAT_HISTORY_PAGE.CHAT_STATUS)}>
    <div className="sp-ticket-status__body">
      <div className="sp-ticket-status__title">
        <Text element="h3" {...makeQAAttributes(QA_CHAT_HISTORY_PAGE.CHAT_STATUS_TITLE)}>
          {name}
        </Text>
      </div>
      {status && (
        <div className="sp-ticket-status__indicator">
          <span className="sp-status-indicator">
            <div className="sp-status-indicator__icon">
              <Icon id={status.icon} size="24" />
            </div>
            <div className="sp-status-indicator__title sp-status-indicator__title--rating" {...makeQAAttributes(QA_CHAT_HISTORY_PAGE.CHAT_STATUS_RATING)}>
              {status.text}
            </div>
          </span>
        </div>
      )}
    </div>
  </div>
);

ChatStatus.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
};

ChatStatus.defaultProps = {
  status: null,
};

export default ChatStatus;
